import ProfitWell from './ProfitWell';

export default {
  ReactComponent: ProfitWell,
  bindings: {
    email: '<',
  },
};
